import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ namespace, scope, elementType, nextTemplate }) =>
    present(
      repository
        .updateSecondaryCriteriaTemplate(
          namespace,
          scope,
          elementType,
          nextTemplate,
        )
        .then((template) => ({ namespace, scope, elementType, template }))
        .catch(() =>
          Promise.reject({ namespace, scope, elementType, nextTemplate }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
